import { createStore } from 'vuex'
import template from './modules/template'
import canvas from './modules/canvas'
import fields from './modules/fields'

export default createStore({
  modules: {
    template,
    canvas,
    fields
  },
  strict: process.env.NODE_ENV !== 'production'
})
